// libs
import { connect } from 'react-redux';

//redux
import { isProductInWishlist } from 'shared/store/wishlist/selectors';
import { getProductId } from 'shared/store/details/selectors';

// components
import WishlistButton from './WishlistButton';

const mapStateToProps = (state: any) => {
  return {
    isWishListProduct: isProductInWishlist(state, getProductId(state)),
  };
};

export default connect(mapStateToProps)(WishlistButton);
